<dialog
  #dialog
  qai-dialog
  [description]="''"
  [heading]="modalHeading"
  (closeButtonClicked)="handleCloseModal()"
>
  <qai-field [label]="fieldLabel">
    @if (open) {
      <qai-multiselect
        [options]="simulationOptions"
        [value]="selectedSimulationIds"
        [saveSelectionsMode]="true"
        [persistSearch]="true"
        [startIcon]="'search'"
        [clearButton]="clearButtonConfig"
        [placeholder]="'simulationBuilder.SIMULATION_NAME_PLACEHOLDER' | transloco"
        (selectionChange)="onSelectionSave($event)"
      ></qai-multiselect>
    }

    <span qaiSlot="label" *ngIf="selectedSimulations.length > 0">
      <button qai-link class="remove-all-button" (click)="onRemoveAll()">
        {{ 'simulationBuilder.BUTTON_REMOVE_ALL' | transloco }}
      </button>
    </span>
  </qai-field>

  <div
    *ngIf="selectedSimulations.length > 0"
    class="selected-simulation-wrapper"
  >
    <qai-field [label]="'simulationBuilder.SIMULATIONS_IN_ASSIGNMENT_LABEL' | transloco">
      <qai-selected-simulations-list
        [simulations]="selectedSimulations"
        (remove)="onRemove($event)"
        maxHeight="300px"
        [showAttemptsAllowed]="showAttemptsAllowed"
        [dragIconKind]="'drag-vertical'"
        [rowStyle]="'compact'"
        [settingOptions]="complianceScoreOptions"
        [settingLabels]="complianceScoreLabels"
        [labels]="listLabels"
        (attemptsChange)="onAttemptsChange($event.id, $event.attempts)"
        (settingChange)="onComplianceScoreChange($event.id, $event.setting)"
        (simulationsChange)="onSimulationListSelectionChange($event)"
      ></qai-selected-simulations-list>
    </qai-field>
  </div>
 
  <div
    class="action-button-container"
    *ngIf="isCreateAssignmentFlow; else addButton"
  >
    <button
      qai-button
      size="medium"
      kind="secondary"
      (click)="handleBackAndCloseClick()"
    >
      {{ 'simulationBuilder.BUTTON_BACK' | transloco }}
    </button>
    <button
      qai-button
      size="medium"
      kind="primary"
      [disabled]="networkRequestInProgress || selectedSimulations.length === 0"
      (click)="assignSimulationsToAssignment()"
    >
      {{ 'simulationBuilder.BUTTON_ASSIGN_LEARNERS' | transloco }}
    </button>
  </div>

  <ng-template #addButton>
    <div class="action-button-container single-button">
      <button
        qai-button
        size="medium"
        kind="primary"
        [disabled]="networkRequestInProgress || selectedSimulations.length === 0"
        (click)="assignSimulationsToAssignment()"
      >
        {{ 'simulationBuilder.BUTTON_ADD_TO_ASSIGNMENT' | transloco }}
      </button>
    </div>
  </ng-template>
</dialog>
